import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import {
  MB_CHECKOUT_REVIEW_NOTES_NORMALIZER,
  MbCheckoutReviewNotesAdapter
} from '../connectors/review-notes'
import { MbCheckoutReviewModel } from '../../models'

@Injectable({
  providedIn: 'root',
})
export class MbOccCheckoutReviewNotesAdapter implements MbCheckoutReviewNotesAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load (cartId: string) {
    return this.http.get(this.getEndpoint(cartId)).pipe(
      this.converter.pipeable(MB_CHECKOUT_REVIEW_NOTES_NORMALIZER)
    )
  }

  post (form: MbCheckoutReviewModel, cartID: string) {
    form = this.converter.convert(form, MB_CHECKOUT_REVIEW_NOTES_NORMALIZER)
    return this.http.post(this.getEndpoint(cartID), form)
  }

  protected getEndpoint (cartId: string) {
    return this.occEndpoints.buildUrl(
      'checkoutReviewNotes',
      {
        urlParams: { cartId },
      }
    )
  }
}
